export default {
      id: "loading-dns-usage",
      viewBox: "0 0 880 1280",
      url: __webpack_public_path__ + "img/icons.svg#loading-dns",
      toString: function () {
        return this.url;
      }
    }